/*
 * Copyright © 2018-2021, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export const clinicCostsSv = {
  BASE_CLINIC_FEE: "Klinikens grundarvode",
  APPOINTMENT_FEE: "Mötesarvode",
  MEDICAL_RECORD_FEE: "Journalarvode",
  SMS_FEE: "Smsarvode",
  INVENTORY_FEE: "Lagerarvode",
  PRESCRIPTION_FEE: "Receptarvode",
  EMPLOYEE_FEE: "Anställdsarvode",
  VET_FEE: "Veterinärarvode",
  ASSISTANT_FEE: "Assistentarvode",
  RECEPTIONIST_FEE: "Receptionist arvode",
  VIDEO_CONSULTATION_FEE: "Video consultation fee",
};
